import moment from 'moment-timezone'
import 'moment/locale/fr'
import 'moment/locale/ja'
import 'moment/locale/es'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import ja from 'date-fns/locale/ja'

import i18n from '../i18n'

const SUPPORTED_LOCALES = ['en', 'fr', 'ja', 'es']
const DEFAULT_LOCALE = 'en'

// the locale imports above set moment's global locale as a side effect; reset it
moment.locale(DEFAULT_LOCALE)

registerLocale('fr', fr)
registerLocale('ja', ja)

export const resolveLocale = (locale) => {
  if (SUPPORTED_LOCALES.includes(locale)) {
    return locale
  }

  const browserLang = navigator.language?.split('-')[0]

  return SUPPORTED_LOCALES.includes(browserLang) ? browserLang : DEFAULT_LOCALE
}

export const applyLocale = (locale) => {
  const safeLocale = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE

  if (i18n.language !== safeLocale) {
    i18n.changeLanguage(safeLocale)
  }

  moment.locale(safeLocale)
  setDefaultLocale(safeLocale)
  document.documentElement.lang = safeLocale
  localStorage.setItem('i18nextLng', safeLocale)
}
